import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { buildManifestOpenPath } from "./manifestsV3DrawerNavigation";

/**
 * Owns the URL wiring for `ManifestsV3`'s row-click drawer: the manifest drawer
 * (path segment `processedManifestId`, read by the caller via
 * `useSelectedIdInUrl`).
 */
export function useManifestsV3RowDrawers(processedManifestId: string | undefined) {
  const navigate = useNavigate();
  const location = useLocation();

  const openManifest = useCallback(
    /** `section` deep-links the drawer to one of its sections; omit for the top. */
    (manifestId: string, section?: string) => {
      navigate(
        buildManifestOpenPath({
          pathname: location.pathname,
          search: location.search,
          currentManifestId: processedManifestId,
          manifestId,
          section,
        }),
        { replace: !!processedManifestId, preventScrollReset: true }
      );
    },
    [navigate, location.pathname, location.search, processedManifestId]
  );

  return { openManifest };
}
